import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            吃瓜视频精选
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            精选深度解读与街采现场，多角度还原娱乐圈热门事件
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-200 cursor-pointer"
            >
              <div className="relative w-full aspect-video bg-background-100 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute bottom-3 right-3 px-2.5 py-1 rounded-md bg-foreground-950/70 text-background-50 text-xs whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/80 flex items-center justify-center">
                    <i className="ri-play-fill text-2xl text-primary-500 ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3">
                  {item.description}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}次观看
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}